import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const SubscriptionContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_STATE = {
  tier: 'free',
  status: 'none',
  features: null,
  expires_at: null,
  plan_key: null,
  loading: true,
};

export const SubscriptionProvider = ({ children }) => {
  const { user } = useAuth();
  const [state, setState] = useState(DEFAULT_STATE);

  const refresh = useCallback(async () => {
    if (!user) {
      setState({ ...DEFAULT_STATE, loading: false });
      return;
    }
    try {
      const { data } = await axios.get(`${API}/subscriptions/me`, { withCredentials: true });
      setState({ ...data, loading: false });
    } catch {
      setState({ ...DEFAULT_STATE, loading: false });
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ ...state, refresh }), [state, refresh]);

  return <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>;
};

export const useSubscription = () => {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error('useSubscription must be used within SubscriptionProvider');
  return ctx;
};

export const hasTier = (currentTier, requiredTier) => {
  const order = { free: 0, pro: 1, elite: 2 };
  return (order[currentTier] ?? 0) >= (order[requiredTier] ?? 0);
};
